import { Reveal } from '../components/Reveal';

const STEPS = [
  {
    year: '2026',
    title: 'Launch',
    items: ['Alpha One Launch', 'LDS Token Launch', 'Package Activation', 'Community Building'],
  },
  {
    year: '2027',
    title: 'Growth',
    items: [
      'Community Expansion',
      'Network Development',
      'Strategic Partnerships',
      'Stronger Ecosystem',
    ],
  },
  {
    year: '2028',
    title: 'Expansion',
    items: ['Web3 Ecosystem Growth', 'New Products & Features', 'Leadership Growth', 'Global Events'],
  },
  {
    year: '2029',
    title: 'Global Reach',
    items: [
      'International Expansion',
      'Enterprise Integrations',
      'Community Rewards',
      'Recognition & Awards',
    ],
  },
  {
    year: '2030',
    title: 'Future Vision',
    items: ['Mature Ecosystem', 'Global Recognition', 'Continuous Innovation', 'Sustainable Growth'],
  },
];

export function Roadmap() {
  return (
    <section id="roadmap" className="section section-alt">
      <div className="container">
        <Reveal className="section-head center">
          <span className="eyebrow" style={{ justifyContent: 'center' }}>
            Alpha One Roadmap
          </span>
          <h2 className="section-title">
            Building today. <span className="accent">Leading tomorrow.</span>
          </h2>
          <p className="section-desc">
            5 years of purpose, countless opportunities — together we build a stronger ecosystem
            for a better future.
          </p>
        </Reveal>

        <div className="roadmap">
          {STEPS.map((step, i) => (
            <Reveal key={step.year} delay={i * 70}>
              <div className="roadmap-step">
                <span className="roadmap-year">{step.year}</span>
                <h4>{step.title}</h4>
                <ul>
                  {step.items.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
